import { CircleHelp } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface Props {
  content: React.ReactNode;
}

export const TooltipHelp = (props: Props): JSX.Element => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <CircleHelp className="w-5 h-5 text-tinted-grey-3 cursor-pointer" />
      </TooltipTrigger>
      <TooltipContent className="max-w-xs whitespace-normal">
        <p>{props.content}</p>
      </TooltipContent>
    </Tooltip>
  );
};
